import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * HeaderTitleService
 */
@Injectable({
	providedIn: 'root'
})
export class HeaderTitleService {
	constructor(private titleService: Title) {}

	public headerTitle: string = 'Pilot Pay';

	public getTitle(route: ActivatedRoute): Observable<string> {
		return of(route).pipe(
			// When we introduce children, we can have multiple activated routes.
			// The parent, the child, and the grandchild are all activated.
			// Each parent can access it's activated child with route firstChild.
			// If we need the deepest activated child then we have to iterate the until the last child
			map(() => {
				// get the first child of the current activated route
				let child: ActivatedRoute = route.firstChild;
				// iterate the active route until the routes have no child
				while (child) {
					// if the current route has a child route
					if (child.firstChild) {
						// if route has a child route then assign first child route as the current route
						child = child.firstChild;
					} else if (child.snapshot.data && child.snapshot.data.title) {
						// check if the data params of current activated route have the title key and value
						// and return if found
						return `${this.headerTitle} - ${child.snapshot.data.title}`;
					} else {
						// if there are no data params then return default header title
						return this.headerTitle;
					}
				}
			})
		);
	}

	public setTitle(title: string): void {
		this.titleService.setTitle(title);
	}
}
